import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild } from '@angular/router';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthGuardMain implements CanActivate, CanActivateChild {

  constructor(
    private authService: AuthService
  ) {
  }
  canActivate(): Observable<boolean> | boolean {

    return this.authService.authorized.pipe(map(b => {
      if (b === true) {
        return true;
      } else {
        window.history.back();
        return false;
      }
    }));
  }

  canActivateChild() {
    return this.authService.authorized;
  }
}
